<template>
  <div class="orderList">
    <el-tabs style="background:white" v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="销售单打印模板" name="toBeDeliverOrder" lazy>
        <V-TobedeliverOrder :TEMPLATE_ID="TEMPLATE_ID"></V-TobedeliverOrder>
      </el-tab-pane>
      <el-tab-pane label="供应商客户打印模板" name="toBeConfirmedOrder" lazy>
        <V-Tobeconfirmeorder></V-Tobeconfirmeorder>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import VTobeconfirmeorder from '@/components/orderPrint/suppliersCustomerPrint';
import VTobedeliverOrder from '@/components/orderPrint/salesOrderPrint';

export default {
  data() {
    return {
      activeName: 'toBeDeliverOrder',
      active: ['toBeDeliverOrder', 'toBeConfirmedOrder', 'historyOrder', 'allOrder', 'orderAuditing', 'orderCheckList'],
      TEMPLATE_ID: this.$route.query.TEMPLATE_ID,
    };
  },
  components: {
    VTobedeliverOrder,
    VTobeconfirmeorder,
  },
  created() {},
  methods: {
    handleClick(tab, event) {
      sessionStorage.setItem('tabactivename', this.activeName);
    },
    tabActive() {
      const flag = this.active.find((item) => {
        if (this.tabActiveName == item) {
          return true;
        }
      });
      if (flag) {
        this.activeName = this.tabActiveName;
      }
    },
  },
};
</script>

<style scoped>
.orderList {
  width: 100%;
}

.orderList>>>.el-tabs__item {
  padding-left: 20px !important;
  width: fit-content !important;
}

.orderList>>>.el-tabs__nav-wrap::after {
  height: 1px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/setting/allPrint.vue